export const mediaConstants = {
  GETALL_REQUEST: 'MEDIA_GETALL_REQUEST',
  GETALL_SUCCESS: 'MEDIA_GETALL_SUCCESS',
  GETALL_FAILURE: 'MEDIA_GETALL_FAILURE',
  GETALL_LOADING: 'MEDIA_GETALL_LOADING',

  UPLOAD_REQUEST: 'MEDIA_UPLOAD_REQUEST',
  UPLOAD_SUCCESS: 'MEDIA_UPLOAD_SUCCESS',
  UPLOAD_FAILURE: 'MEDIA_UPLOAD_FAILURE',
  UPLOAD_PROCESSING: 'MEDIA_UPLOAD_PROCESSING',

  DELETE_REQUEST: 'MEDIA_DELETE_REQUEST',
  DELETE_SUCCESS: 'MEDIA_DELETE_SUCCESS',
  DELETE_FAILURE: 'MEDIA_DELETE_FAILURE',
  DELETE_PROCESSING: 'MEDIA_DELETE_PROCESSING',
}